/** @jsxImportSource @emotion/react */

import { useTheme } from '@emotion/react';

type questionProps = {
  question: string;
};

export const QuestionHeading = ({ question }: questionProps) => {
  const theme = useTheme();

  return (
    <legend
      css={{
        color: theme.color.slateDark,
        fontFamily: theme.fontFamily.heading,
        fontSize: theme.fontSizes[6],
        fontWeight: theme.fontWeights.semibold,
        marginBottom: '1.5rem',
        textAlign: 'center',

        [`@media (min-width: 640px)`]: {
          marginBottom: '2.5rem',
          fontSize: theme.fontSizes[10]
        }
      }}
    >
      {question}
    </legend>
  );
};

QuestionHeading.displayName = 'QuestionHeading';
